import { forwardRef, type MouseEvent as ReactMouseEvent } from 'react'
import type { KibButtonNewProps } from '@chewy/kib-controls-react'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibSparklesIcon } from '@chewy/kib-icons-react'
import classNames from 'classnames'

import { useIsAgentChatEnabled } from '~/hooks/useIsAgentChatEnabled'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './AgentIngressButton.module.scss'

export interface AgentIngressButtonProps
  extends Omit<KibButtonNewProps, 'icon' | 'iconPosition'> {
  onClick?: (event: ReactMouseEvent<HTMLButtonElement>) => void
  text: string
}

/**
 * Button component for agent ingress functionality.
 * This is a variant of KibButtonNew with specific styling for
 * AI Assistant ingress buttons.
 */
const AgentIngressButton = forwardRef<
  HTMLButtonElement,
  AgentIngressButtonProps
>(({ className, text, onClick, size = 'small', ...props }, ref) => {
  const isAgentChatEnabled = useIsAgentChatEnabled()

  if (!isAgentChatEnabled) {
    return null
  }

  return (
    <KibButtonNew
      {...props}
      className={classNames(styles.ingressButton, className)}
      icon={<KibSparklesIcon height={20} width={20} />}
      iconPosition="start"
      ref={ref}
      size={size}
      onClick={onClick}
    >
      {text}
    </KibButtonNew>
  )
})

AgentIngressButton.displayName = 'AgentIngressButton'

export default AgentIngressButton
